const client = require('../../../server/src/config/application').client()
const apps = require('./apps')

const application = Object.assign({}, client, apps[client.name])

export default application



// WEBPACK FOOTER //
// ./src/config/default.js